import { ISoundsGenre } from 'store/types/audio'
import { TAudioType } from 'types/audio'

export const PROJECT_AUDIO_TYPES: Record<TAudioType, TAudioType> = {
  SOUND: 'SOUND',
  TTS: 'TTS',
  VOICE_OVER: 'VOICE_OVER'
}

export const sortGenresByNameInAlphabeticalOrder = (
  genres: ISoundsGenre[]
): ISoundsGenre[] => genres.sort((a, b) => a.genre.localeCompare(b.genre))
